/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../core/Navbar";
import Row from "../core/Row";
import Col from "../core/Col";
import styles from "../css/error.boundary.styles.css";

const ErrorPage = () => {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <div id="headerWrapper" className={styles.headerWrapper}>
        {/* Header */}
        <Navbar>
          <Row>
            <Col xs="12" className="p-0">
              <a href="/">{t("common:back_to_home")}</a>
            </Col>
          </Row>
        </Navbar>
      </div>
      {/* Body */}
      <Row className="under-construction-row">
        <Col xs="12" className="text-center">
          <Row>
            <Col xs="12" className="text-center">
              {t("common:something_went_wrong")}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ErrorPage;
